<template>
  <AccountantsSubmenu
    :items="menuItems"
  >
    <template v-slot:titletop>
      <!-- <div class="submenu-title">
        {{ $gettext('Communication') }}
      </div> -->
    </template>
    <template v-slot:bottom>

    </template>
  </AccountantsSubmenu>
</template>

<script>
import AccountantsSubmenu from '@/components/accountants/menus/AccountantsSubmenu.vue'
import GekkoButton from "@/components/GekkoButton";

export default {
  name: 'AccountantsCommunicationMenu',
  components: { 
    AccountantsSubmenu,
    GekkoButton
  },
  computed: {
    menuItems() {
      return [
        {
          key: 'communication',
          label: this.$gettext('All messages'),
          name: 'Communication',
          icon: 'fa-users',
          analytics: 'communication',
        },
        // {
        //   key: 'pending',
        //   label: 'Something Else',
        //   name: '',
        //   icon: 'fa-clock',
        // },
      ]
    },
  },
}
</script>

<style scoped lang="scss">
</style>
